import { IComponentController } from '@wix/editor-elements-types';
import { IMatrixGalleryControllerActions } from '../MatrixGallery.types';

const mapActionsToProps: IComponentController = ({
  updateProps,
}): IMatrixGalleryControllerActions => ({
  setItemToFocusIndex: (index: number) => {
    updateProps({
      itemToFocusIndex: index,
    });
  },
  setNumberOfExtraRows: (extraRows: number) => {
    updateProps({
      numberOfExtraRows: extraRows,
    });
  },
});

export default mapActionsToProps;
